import { DialogClose } from "@radix-ui/react-dialog"
import React from "react"
import { Button } from "../Button"
import { useTranslation } from "next-i18next"
import { cn } from "@/utils/helpers"

type DialogCommonCloseProps = {
  className?: string
}

/**
 * The close button used in all Sheets and Modals.
 */
export const DialogCommonClose = ({ className }: DialogCommonCloseProps) => {
  const { t } = useTranslation("common")
  return (
    <DialogClose asChild>
      <Button
        text={t("close")}
        variant="text"
        size="icon"
        iconName="close"
        type="button"
        className={cn("text-on-surface-variant m-1 ml-auto", className)}
      />
    </DialogClose>
  )
}

export const DialogCommonSmallZoomTransition =
  "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 duration-200"
